
function diffData(ids: string, id: string) {
  const arr = ids.split(',')
  if (!arr.includes(id)) {
    arr.push(id)
  }
  return arr.join(',')
}

function formatParamsAndQuery(route: any) {
  const { params, query } = route

  if (params.cityId) {
    query.city_ids = query.city_ids
      ? diffData(query.city_ids, params.cityId)
      : params.cityId
  }
  if (params.countryId) {
    query.country_ids = query.country_ids ? diffData(query.country_ids,
      params.countryId) : params.countryId
  }
  if (params.frontendId) {
    if (query.frontend_id_list) {
      if (!query.l1_front_id) {
        query.frontend_id_list = diffData(
          query.frontend_id_list, params.frontendId)
      }
    } else {
      query.frontend_id_list = params.frontendId
    }
  }
  return query
}

interface Route {
  query: any
  params: any
  [key: string]: any
}

export function formatQuery(route: Route) {
  const { query, params } = route

  if (params.cityId) {
    query.city_id = query.city_id ? diffData(query.city_id, params.cityId) : params.cityId
  }
  if (params.countryId) {
    query.country_id = query.country_id ? diffData(query.country_id, params.countryId) : params.countryId
  }
  if (params.frontendId) {
    query.frontend_id_list = query.frontend_id_list ? diffData(query.frontend_id_list, params.frontendId) : params.frontendId
  }

  return query
}

export default formatParamsAndQuery
